var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { MetricsTable } from './components';
export const FilespaceInfo = ({ data }) => {
    _react_refresh_temp_2();
    const info = useMemo(() => [
        {
            name: 'Filespace Id',
            value: data.id,
        },
        {
            name: 'Workspace Id',
            value: data.workspaceId,
        },
        {
            name: 'Name',
            value: data.name,
        },
        {
            name: 'Subsciption Type',
            value: data.subscriptionType,
        },
        {
            name: 'Storage Owner',
            value: data.storageOwner,
        },
        {
            name: 'Storage Provider Id',
            value: data.storageProviderId,
        },
        {
            name: 'Storage Region Id',
            value: data.storageRegionId,
        },
        {
            name: 'Storage Region Name',
            value: data.storageRegionName,
        },
        {
            name: 'Storage Bucket',
            value: data.storageBucket,
        },
        {
            name: 'Used Storage',
            value: data.usedStorage,
        },
        {
            name: 'Hub Websocket Endpoints',
            value: data.hubWebSocketEndpoints,
        },
        {
            name: 'Hub Data Endpoints',
            value: data.hubDataEndpoints,
        },
        {
            name: 'Discovery Service Endpoint',
            value: data.discoveryServiceEndpoint,
        },
        {
            name: 'Status',
            value: data.status,
        },
        {
            name: 'Created At',
            value: data.createdAt,
        },
        {
            name: 'Updated At',
            value: data.updatedAt,
        },
    ], [data]);
    return _jsx(MetricsTable, { data: info });
};
_react_refresh_temp_1 = FilespaceInfo;
$RefreshReg$(_react_refresh_temp_1, "FilespaceInfo");
_react_refresh_temp_2(FilespaceInfo, "D1/SU69G7ToKj9fgVRwBj1jmp1c=");
